import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomeSlider from "./components/HomeSlider";
import BrandSlider from "./components/BrandSlider";
import CategorySlider from "./components/CategorySlider";
import HotPicks from "./components/HotPicks";
import AboutUs from "./components/AboutUs";
import GoogleMap from "./components/GoogleMap";
import ProductsPage from "./pages/ProductsPage";
import ProductDetails from "./pages/ProductDetails";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import OrderConfirmation from "./pages/OrderConfirmation";
import Orders from "./pages/Orders";

function HomePage() {
  return (
    <div className="App">
      <Navbar />
      <section id="home">
        <HomeSlider />
      </section>
      <section id="brands">
        <BrandSlider />
      </section>
      <section id="categories">
        <h2>Shop By Categories</h2>
        <CategorySlider />
      </section>
      <section id="hot-picks">
        <h2>Hot Picks</h2>
        <HotPicks />
      </section>
      <section id="about">
        <AboutUs />
      </section>
      <section id="contact">
        <h2>Your Next Adventure Starts with the Right Luggage – Drop By!</h2>
        <GoogleMap />
      </section>
      <Footer />
    </div>
  );
}

function ProductsPageWrapper() {
  return (
    <div className="App">
      <Navbar />
      <ProductsPage />
      <Footer />
    </div>
  );
}

function ProductDetailsWrapper() {
  return (
    <div className="App">
      <Navbar />
      <ProductDetails />
      <Footer />
    </div>
  );
}

function CheckoutWrapper() {
  return (
    <div className="App">
      <Navbar />
      <Checkout />
      <Footer />
    </div>
  );
}

function LoginWrapper() {
  return (
    <div className="App">
      <Navbar />
      <Login />
      <Footer />
    </div>
  );
}

function OrderConfirmationWrapper() {
  return (
    <div className="App">
      <Navbar />
      <OrderConfirmation />
      <Footer />
    </div>
  );
}

function OrdersWrapper() {
  return (
    <div className="App">
      <Navbar />
      <Orders />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/products/:categoryId" element={<ProductsPageWrapper />} />
        <Route path="/product/:productId" element={<ProductDetailsWrapper />} />
        <Route path="/checkout/:productId" element={<CheckoutWrapper />} />
        <Route path="/login" element={<LoginWrapper />} />
        <Route path="/order-confirmation/:orderId" element={<OrderConfirmationWrapper />} />
        <Route path="/orders" element={<OrdersWrapper />} />
      </Routes>
    </Router>
  );
}

export default App;